import {AppEntities} from "src/config/entities";
import {DocumentService} from "./DocumentService";
import {IVendorInvoiceDto} from 'src/dtos/documents/VendorInvoices/IVendorInvoiceDto';
import {IVendorInvoiceProductDto} from "src/dtos/documents/VendorInvoices/IVendorInvoiceProductDto";
import {IVendorInvoiceServiceDto} from "src/dtos/documents/VendorInvoices/IVendorInvoiceServiceDto";
import {
    IPurchaseOrderProductDto
} from "../../components/Pages/Documents/Purchases/PurchaseOrders/dtos/IPurchaseOrderProductDto";

export class VendorInvoicesService extends DocumentService {
    async Clone(id: string) {
        const newObject = await this.Get(id);
        const clonedObject = {...newObject};
        return clonedObject;
    }

    async createBasedAtOrder(id: string) {
        const orderDto = await AppEntities.PurchaseOrders.getDataService().Get(id);
        const newCustomerInvoice: IVendorInvoiceDto = {...orderDto};
        newCustomerInvoice.paymentOffsets = [];
        newCustomerInvoice.products = [];
        newCustomerInvoice.services = [];
        orderDto.products.forEach((productDto: IPurchaseOrderProductDto) => {
            const newVendorInvoiceGoods: IVendorInvoiceProductDto = {...productDto};
            newVendorInvoiceGoods.id = undefined;
            newCustomerInvoice.products.push(newVendorInvoiceGoods);
        });
        orderDto.services.forEach((good: IVendorInvoiceServiceDto) => {
            const newVendorInvoiceGoods: IVendorInvoiceServiceDto = {...good};
            newVendorInvoiceGoods.id = undefined;
            // newCustomerInvoice.products.push(newVendorInvoiceGoods);
        });
        
        return newCustomerInvoice;
    };
}